module.exports = __webpack_public_path__ + "static/aga-logo-6e0c4dd5b53cfcab3a36a7e8e1ac8a53.svg";